export default function handleSubpageNavigation() {
    $('body').on('click', '.js-toggle-subpage-menu', function () {
        $(this).parents('.js-subpage-menu-section').toggleClass('subpage-menu-section--active');
        return false;
    });
}